module.exports = __webpack_public_path__ + "static/media/facilitador.e2151779.jpg";